<ng-container [ngSwitch]="pageState">
  <ng-container *ngSwitchCase="pageStateEnum.LOADING">
    <div class="ui one column padded grid">
      <div class="column">
        <monorepo-loading-spinner
          [loaderType]="LoadingTypeEnum.SPINNER"
        ></monorepo-loading-spinner>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="pageStateEnum.LOADED">
    <signgaze-listing-images
      *ngIf="screenListing?.screenImages"
      [screenImages]="screenListing?.screenImages"
    ></signgaze-listing-images>
    <div>
      <div class="ui basic very padded fitted horizontally segment">
        <div class="ui container">
          <div class="ui grid">
            <div
              class="sixteen-wide-mobile mobile-only column"
              id="bookNowMobil"
            >
              <signgaze-book-screen
                [screenPrice]="screenListing?.screenPrice"
                [isUserSignedIn]="isUserSignedIn"
                [isScreenAvailableForBooking]="
                  screenListing?.isScreenAvailableForBooking
                "
              ></signgaze-book-screen>
            </div>
            <div class="sixteen-wide-tablet tablet-only column">
              <signgaze-book-screen
                [screenPrice]="screenListing?.screenPrice"
                [isUserSignedIn]="isUserSignedIn"
                [isScreenAvailableForBooking]="
                  screenListing?.isScreenAvailableForBooking
                "
              ></signgaze-book-screen>
            </div>
            <div
              class="
                sixteen-wide-mobile sixteen-wide-tablet
                ten-wide-computer
                column
              "
            >
              <div class="ui basic segments">
                <div class="ui light border segment">
                  <div class="ui horizontal list">
                    <div class="item">
                      <i class="yellow star icon"></i>
                      4.9(98)
                    </div>
                    <div class="item grey text">
                      {{ screenListing?.locality }}, {{ screenListing?.city }},
                      {{ screenListing?.country }}
                    </div>
                  </div>
                  <h2 class="ui header screen title">
                    {{ screenListing?.screenName }}, {{ screenListing?.state }}
                  </h2>
                </div>
                <div class="ui light border segment">
                  <div class="ui basic padded segment fitted horizontally">
                    <h3 class="ui header fw-100">Quick Overview</h3>
                    <div class="ui basic padded fitted horizontally segment">
                      <div class="ui divided three column middle aligned grid">
                        <div class="stretched row">
                          <div class="sixteen-wide-mobile column">
                            <h4 class="ui fw-100 header m-0">
                              <div class="sub header grey text mb-5">
                                Screen Location Type
                              </div>
                              {{ screenListing?.locationType }}
                            </h4>
                            <br class="pure-visible-xs" />
                          </div>
                          <div class="sixteen-wide-mobile column xs-no-shadow">
                            <h4 class="ui fw-100 header m-0">
                              <div class="sub header grey text mb-5">
                                Screen Location
                              </div>
                              {{ screenListing?.locality }},
                              {{ screenListing?.pincode }}
                            </h4>
                            <br class="pure-visible-xs" />
                          </div>
                          <div class="sixteen-wide-mobile column xs-no-shadow">
                            <h4 class="ui fw-100 header">
                              <div class="sub header grey text mb-5">
                                Latitude / Longitude
                              </div>
                              {{ screenListing?.latitude }} /
                              {{ screenListing?.longitude }}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ui light border segment">
                  <div class="ui basic fitted horizontally segment">
                    <div class="ui text justified">
                      <p class="grey text">
                        {{ screenListing?.screenDescription }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="ui light border segment">
                  <div class="ui basic padded segment fitted horizontally">
                    <h3 class="ui header fw-100">About Screen</h3>
                    <div class="ui basic padded fitted horizontally segment">
                      <div class="ui three column grid">
                        <div class="row">
                          <div
                            class="sixteen-wide-mobile eight-wide-tablet column"
                          >
                            <h4 class="ui fw-100 header">
                              <img src="assets/images/icons/screen-size.svg" />
                              <div class="content">
                                {{ screenListing?.screenHeight }}cm -
                                {{ screenListing?.screenWidth }} cm
                                <div class="sub header grey text">
                                  Screen Size
                                </div>
                              </div>
                            </h4>
                            <br class="pure-visible-xs" />
                          </div>
                          <div
                            class="sixteen-wide-mobile eight-wide-tablet column"
                          >
                            <h4 class="ui fw-100 header">
                              <img src="assets/images/icons/orientation.svg" />
                              <div class="content">
                                {{ screenListing?.screenOrientation }}
                                <div class="sub header grey text">
                                  Orientation
                                </div>
                              </div>
                            </h4>
                            <br class="pure-visible-xs" />
                          </div>
                          <div
                            class="sixteen-wide-mobile eight-wide-tablet column"
                          >
                            <h4 class="ui fw-100 header">
                              <img src="assets/images/icons/resolution.svg" />
                              <div class="content">
                                {{ screenListing?.screenResolution }}
                                <div class="sub header grey text">
                                  Resolution
                                </div>
                              </div>
                            </h4>
                            <br class="pure-visible-xs" />
                          </div>
                        </div>
                        <div class="row">
                          <div
                            class="sixteen-wide-mobile eight-wide-tablet column"
                          >
                            <h4 class="ui fw-100 header">
                              <img
                                src="assets/images/icons/screen-aspect-ratio.svg"
                              />
                              <div class="content">
                                {{ screenListing?.screenHeight }}cm -
                                {{ screenListing?.screenWidth }} cm
                                <div class="sub header grey text">
                                  Screen Aspect Ratio
                                </div>
                              </div>
                            </h4>
                            <br class="pure-visible-xs" />
                          </div>
                          <div
                            class="sixteen-wide-mobile eight-wide-tablet column"
                          >
                            <h4 class="ui fw-100 header">
                              <img src="assets/images/icons/screen-type.svg" />
                              <div class="content">
                                {{ screenListing?.screenType }}
                                <div class="sub header grey text">
                                  Screen Type
                                </div>
                              </div>
                            </h4>
                            <br class="pure-visible-xs" />
                          </div>
                          <div
                            class="sixteen-wide-mobile eight-wide-tablet column"
                          >
                            <h4 class="ui fw-100 header">
                              <img
                                src="../../../../../assets/images/icons/screen-place.svg"
                              />
                              <div class="content">
                                {{ screenListing?.screenPlace }}
                                <div class="sub header grey text">
                                  Screen Place
                                </div>
                              </div>
                            </h4>
                            <br class="pure-visible-xs" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ui light border segment">
                  <div class="ui basic padded segment fitted horizontally">
                    <h3 class="ui header fw-100">Audience info</h3>
                    <div class="ui basic padded fitted horizontally segment">
                      <div class="ui three column grid">
                        <div class="row">
                          <div
                            class="sixteen-wide-mobile eight-wide-tablet column"
                          >
                            <h4 class="ui fw-100 header">
                              <img src="assets/images/icons/gender-ratio.svg" />
                              <div class="content">
                                {{ screenListing?.genderRatio }}
                                <div class="sub header grey text">
                                  Gender Ratio
                                </div>
                              </div>
                            </h4>
                            <br class="pure-visible-xs" />
                          </div>
                          <div
                            class="sixteen-wide-mobile eight-wide-tablet column"
                          >
                            <h4 class="ui fw-100 header">
                              <img
                                src="assets/images/icons/monthly-footfall.svg"
                              />
                              <div class="content">
                                {{ screenListing?.monthlyFootfall }}
                                <div class="sub header grey text">
                                  Monthly Footfall
                                </div>
                              </div>
                            </h4>
                            <br class="pure-visible-xs" />
                          </div>
                          <div
                            class="sixteen-wide-mobile eight-wide-tablet column"
                          >
                            <h4 class="ui fw-100 header">
                              <img src="assets/images/icons/ad-language.svg" />
                              <div class="content">
                                {{ screenListing?.languages }}
                                <div class="sub header grey text">
                                  Ad Language
                                </div>
                              </div>
                            </h4>
                            <br class="pure-visible-xs" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ui light border segment">
                  <div class="ui basic padded segment fitted horizontally">
                    <h3 class="ui header fw-100">Category</h3>
                    <div class="ui basic fitted horizontally padded segment">
                      <div class="ui labels">
                        <div
                          class="ui large label"
                          *ngFor="
                            let screenCategory of screenListing?.screenCategories
                          "
                        >
                          {{ screenCategory }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ui light border segment">
                  <div class="ui basic padded fitted horizontally segment">
                    <h3 class="ui header fw-100">Restrictions</h3>
                    <div>
                      <p class="grey text">
                        <i class="exclamation triangle large red icon"></i>
                        {{ screenListing?.screenRestrictions }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="ui light border segment">
                  <signgaze-listing-hours
                    [screenHours]="screenListing?.storeHours"
                  ></signgaze-listing-hours>
                </div>
                <!-- <div class="ui light border segment">
                <signgaze-listing-reviews></signgaze-listing-reviews>
              </div> -->
                <!-- <div class="ui light border segment">
                <signgaze-listing-comments></signgaze-listing-comments>
              </div> -->
              </div>
            </div>
            <div class="six-wide-computer computer-only column ui sticky">
              <signgaze-book-screen
                [screenPrice]="screenListing?.screenPrice"
                [isUserSignedIn]="isUserSignedIn"
                [isScreenAvailableForBooking]="
                  screenListing?.isScreenAvailableForBooking
                "
              ></signgaze-book-screen>

              <div class="ui padded segment">
                <h5 class="ui header fw-100">
                  Got Questions?
                  <div class="sub header grey text">
                    Call us or whatsapp us at:
                  </div>
                </h5>
                <div role="list" class="ui horizontal list">
                  <!-- <a role="listitem" class="item">
                    <button class="ui primary button" disabled>Message</button>
                  </a>
                  <div class="item">
                    or
                  </div> -->
                  <a href="tel:+8591290752" class="item"> +91 8591290752 </a>
                  <div class="item">or</div>
                  <a class="item">
                    <img
                      src="assets/images/whatsapp.png"
                      width="20px"
                      class="ui image"
                    />
                  </a>
                </div>
              </div>
              <signgaze-listing-owner
                [ownerId]="screenListing?.ownerId"
              ></signgaze-listing-owner>
            </div>
          </div>
        </div>
      </div>
      <signgaze-trending-categories-container></signgaze-trending-categories-container>
      <signgaze-trending-screen-container></signgaze-trending-screen-container>
    </div>

    <div
      #addToCart
      class="ui attached bottom fixed footer fitted segment pure-visible-xs"
    >
      <div class="ui basic fitted segment">
        <button class="ui primary primary large fluid button">
          Add to Cart
        </button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="pageStateEnum.NO_LISTING">
    <div class="ui basic segment">
      <monorepo-empty-state
        [statetype]="StateTypeEnum.UPLOAD"
      ></monorepo-empty-state>
    </div>
  </ng-container>
</ng-container>
